import { CALL_API } from "../../middlewares/api";
import * as ordersActions from "../orders/actions";

import _ from "underscore";
import moment from "moment";

export const GET_CREDIT_BY_GUID_REQUEST = "GET_CREDIT_BY_GUID_REQUEST";
export const GET_CREDIT_BY_GUID_SUCCESS = "GET_CREDIT_BY_GUID_SUCCESS";
export const GET_CREDIT_BY_GUID_ERROR = "GET_CREDIT_BY_GUID_ERROR";

export function get_credit_by_guid(guid) {
  return {
    [CALL_API]: {
      endpoint: `/api/admin/get-credit-summary?Guid=${guid}`,
      authenticatedRequest: true,
      types: [
        GET_CREDIT_BY_GUID_REQUEST,
        GET_CREDIT_BY_GUID_SUCCESS,
        GET_CREDIT_BY_GUID_ERROR,
      ],
    },
  };
}

export const ACCOUNTING_LIST_SWEDEN_GET_REQUEST =
  "ACCOUNTING_LIST_SWEDEN_GET_REQUEST";
export const ACCOUNTING_LIST_SWEDEN_GET_SUCCESS =
  "ACCOUNTING_LIST_SWEDEN_GET_SUCCESS";
export const ACCOUNTING_LIST_SWEDEN_GET_ERROR =
  "ACCOUNTING_LIST_SWEDEN_GET_ERROR";

export function get_accounting_sweden() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/accounting/list-for-export-sweden",
      authenticatedRequest: true,
      types: [
        ACCOUNTING_LIST_SWEDEN_GET_REQUEST,
        ACCOUNTING_LIST_SWEDEN_GET_SUCCESS,
        ACCOUNTING_LIST_SWEDEN_GET_ERROR,
      ],
    },
  };
}

export const ACCOUNTING_LIST_EUROPE_GET_REQUEST =
  "ACCOUNTING_LIST_EUROPE_GET_REQUEST";
export const ACCOUNTING_LIST_EUROPE_GET_SUCCESS =
  "ACCOUNTING_LIST_EUROPE_GET_SUCCESS";
export const ACCOUNTING_LIST_EUROPE_GET_ERROR =
  "ACCOUNTING_LIST_EUROPE_GET_ERROR";

export function get_accounting_europe() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/accounting/list-for-export-europe",
      authenticatedRequest: true,
      types: [
        ACCOUNTING_LIST_EUROPE_GET_REQUEST,
        ACCOUNTING_LIST_EUROPE_GET_SUCCESS,
        ACCOUNTING_LIST_EUROPE_GET_ERROR,
      ],
    },
  };
}

export const ACCOUNTING_EXPORT_SWEDEN_REQUEST =
  "ACCOUNTING_EXPORT_SWEDEN_REQUEST";
export const ACCOUNTING_EXPORT_SWEDEN_SUCCESS =
  "ACCOUNTING_EXPORT_SWEDEN_SUCCESS";
export const ACCOUNTING_EXPORT_SWEDEN_ERROR = "ACCOUNTING_EXPORT_SWEDEN_ERROR";

export function export_accounting_sweden() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/accounting/export-sweden",
      authenticatedRequest: true,
      method: "POST",
      types: [
        ACCOUNTING_EXPORT_SWEDEN_REQUEST,
        ACCOUNTING_EXPORT_SWEDEN_SUCCESS,
        ACCOUNTING_EXPORT_SWEDEN_ERROR,
      ],
    },
  };
}

export const ACCOUNTING_EXPORT_EUROPE_REQUEST =
  "ACCOUNTING_EXPORT_EUROPE_REQUEST";
export const ACCOUNTING_EXPORT_EUROPE_SUCCESS =
  "ACCOUNTING_EXPORT_EUROPE_SUCCESS";
export const ACCOUNTING_EXPORT_EUROPE_ERROR = "ACCOUNTING_EXPORT_EUROPE_ERROR";

export function export_accounting_europe() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/accounting/export-europe",
      authenticatedRequest: true,
      method: "POST",
      types: [
        ACCOUNTING_EXPORT_EUROPE_REQUEST,
        ACCOUNTING_EXPORT_EUROPE_SUCCESS,
        ACCOUNTING_EXPORT_EUROPE_ERROR,
      ],
    },
  };
}

export const DEPOSIT_PAYMENTS_REQUEST = "DEPOSIT_PAYMENTS_REQUEST";
export const DEPOSIT_PAYMENTS_SUCCESS = "DEPOSIT_PAYMENTS_SUCCESS";
export const DEPOSIT_PAYMENTS_ERROR = "DEPOSIT_PAYMENTS_ERROR";

export function get_deposit_payments() {
  var uri = "/ondepositbg";

  //When deposit payments are fetched we additionaly want to match them and fetch deposit orders
  return {
    [CALL_API]: {
      endpoint: "/api/admin" + uri,
      authenticatedRequest: true,
      method: "GET",
      types: [
        DEPOSIT_PAYMENTS_REQUEST,
        { method: deposit_payments_fetched },
        DEPOSIT_PAYMENTS_ERROR,
      ],
    },
  };
}

function deposit_payments_fetched(response) {
  return (dispatch) => {
    dispatch({
      type: DEPOSIT_PAYMENTS_SUCCESS,
      response,
    });

    let toMatch = {};

    for (var item of response) {
      if (item.RefCode) toMatch[item.Id] = item.RefCode.trim();
    }

    dispatch(
      ordersActions.get_deposits([
        ordersActions.DEPOSIT_LIST_GET_REQUEST,
        { method: deposit_orders_fetched.bind(this, toMatch) },
        ordersActions.DEPOSIT_LIST_GET_ERROR,
      ]),
    );
  };
}

function deposit_orders_fetched(toMatch, response) {
  return (dispatch) => {
    dispatch({
      type: ordersActions.DEPOSIT_LIST_GET_SUCCESS,
      response,
    });

    dispatch(get_deposit_matches(toMatch, response));
  };
}

export const MATCHED_INVOICE_PAYMENTS_REQUEST =
  "MATCHED_INVOICE_PAYMENTS_REQUEST";
export const MATCHED_INVOICE_PAYMENTS_SUCCESS =
  "MATCHED_INVOICE_PAYMENTS_SUCCESS";
export const MATCHED_INVOICE_PAYMENTS_ERROR = "MATCHED_INVOICE_PAYMENTS_ERROR";

export function get_invoice_matched_payments() {
  var uri = "/oninvoicebg/matched";

  return {
    [CALL_API]: {
      endpoint: "/api/admin" + uri,
      authenticatedRequest: true,
      method: "GET",
      types: [
        MATCHED_INVOICE_PAYMENTS_REQUEST,
        MATCHED_INVOICE_PAYMENTS_SUCCESS,
        MATCHED_INVOICE_PAYMENTS_ERROR,
      ],
    },
  };
}

export const INVOICE_PAYMENTS_REQUEST = "INVOICE_PAYMENTS_REQUEST";
export const INVOICE_PAYMENTS_SUCCESS = "INVOICE_PAYMENTS_SUCCESS";
export const INVOICE_PAYMENTS_ERROR = "INVOICE_PAYMENTS_ERROR";

export function get_invoice_payments() {
  var uri = "/oninvoicebg";

  return {
    [CALL_API]: {
      endpoint: "/api/admin" + uri,
      authenticatedRequest: true,
      method: "GET",
      types: [
        INVOICE_PAYMENTS_REQUEST,
        INVOICE_PAYMENTS_SUCCESS,
        INVOICE_PAYMENTS_ERROR,
      ],
    },
  };
}

export const DEPOSIT_MATCH_REQUEST = "DEPOSIT_MATCH_REQUEST";
export const DEPOSIT_MATCH_SUCCESS = "DEPOSIT_MATCH_SUCCESS";
export const DEPOSIT_MATCH_ERROR = "DEPOSIT_MATCH_ERROR";

export function get_deposit_matches(toMatch, deposits) {
  return (dispatch) => {
    var depositMatches = {};

    for (var paymentId of Object.keys(toMatch)) {
      var depositMatch = _.find(deposits, (value) => {
        return value.RefCode == toMatch[paymentId];
      });

      if (depositMatch) {
        depositMatches[paymentId] = {
          RefCode: depositMatch.Id,
          RemoveFromSending: false,
        };
      }
    }

    dispatch({
      type: DEPOSIT_MATCH_SUCCESS,
      response: depositMatches,
    });
  };
}

export const MANUAL_DEPOSIT_MATCH_SUCCESS = "MANUAL_DEPOSIT_MATCH_SUCCESS";
export const MANUAL_DEPOSIT_MATCH_ERROR = "MANUAL_DEPOSIT_MATCH_ERROR";

export function match_deposit_manually(depositId, paymentId, depositPayments) {
  return (dispatch) => {
    var match = _.find(depositPayments.data, (item) => {
      return item.Id == paymentId;
    });

    if (!match) {
      dispatch({
        type: MANUAL_DEPOSIT_MATCH_ERROR,
      });
      //alert('Payment with this id was not found');
    } else {
      var response = {};
      response[paymentId] = { RefCode: depositId, RemoveFromSending: false };

      dispatch({
        type: MANUAL_DEPOSIT_MATCH_SUCCESS,
        response,
      });
    }
  };
}

export const REGISTER_INVESTOR_DEPOSIT_REQUEST =
  "REGISTER_INVESTOR_DEPOSIT_REQUEST";
export const REGISTER_INVESTOR_DEPOSIT_SUCCESS =
  "REGISTER_INVESTOR_DEPOSIT_SUCCESS";
export const REGISTER_INVESTOR_DEPOSIT_ERROR =
  "REGISTER_INVESTOR_DEPOSIT_ERROR";

export const REGISTER_DEPOSIT_PAYMENT_REQUEST =
  "REGISTER_DEPOSIT_PAYMENT_REQUEST";
export const REGISTER_DEPOSIT_PAYMENT_SUCCESS =
  "REGISTER_DEPOSIT_PAYMENT_SUCCESS";
export const REGISTER_DEPOSIT_PAYMENT_ERROR = "REGISTER_DEPOSIT_PAYMENT_ERROR";

export const REGISTER_INVOICE_PAYMENT_REQUEST =
  "REGISTER_INVOICE_PAYMENT_REQUEST";
export const REGISTER_INVOICE_PAYMENT_SUCCESS =
  "REGISTER_INVOICE_PAYMENT_SUCCESS";
export const REGISTER_INVOICE_PAYMENT_ERROR = "REGISTER_INVOICE_PAYMENT_ERROR";

export function register_payment(paymentData, type) {
  let uri = "";
  if (type === "investor_deposit") {
    uri = "/api/admin/register-investor-deposit";
    paymentData.BankPaymentId = paymentData.PaymentId.toString();
    paymentData.Ocr = paymentData.RefCode.toString();
    delete paymentData.PaymentId;
    delete paymentData.RefCode;
  } else if (type === "invoice") {
    delete paymentData.Currency;
    delete paymentData.IsSalesPerformanceExcluded;
    uri = "/api/admin/fundorders/invoicebg/register";
  } else if (type === "dca_collection") {
    delete paymentData.Currency;
    delete paymentData.IsSalesPerformanceExcluded;
    uri = "/api/admin/fundorders/invoicebg/register-dca-collection";
  } else throw new Error("invalid payment type");

  let types = [];
  switch (type) {
    case "deposit":
      types = [
        REGISTER_DEPOSIT_PAYMENT_REQUEST,
        REGISTER_DEPOSIT_PAYMENT_SUCCESS,
        REGISTER_DEPOSIT_PAYMENT_ERROR,
      ];
      break;
    case "investor_deposit":
      types = [
        REGISTER_INVESTOR_DEPOSIT_REQUEST,
        { method: investor_deposit_registered },
        REGISTER_INVESTOR_DEPOSIT_ERROR,
      ];
      break;
    default:
      types = [
        REGISTER_INVOICE_PAYMENT_REQUEST,
        REGISTER_INVOICE_PAYMENT_SUCCESS,
        REGISTER_INVOICE_PAYMENT_ERROR,
      ];
      break;
  }

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "POST",
      data: paymentData,
      types,
    },
  };
}

export const CHANGE_INVESTOR_DEPOSIT_OCR_REQUEST =
  "CHANGE_INVESTOR_DEPOSIT_OCR_REQUEST";
export const CHANGE_INVESTOR_DEPOSIT_OCR_SUCCESS =
  "CHANGE_INVESTOR_DEPOSIT_OCR_SUCCESS";
export const CHANGE_INVESTOR_DEPOSIT_OCR_ERROR =
  "CHANGE_INVESTOR_DEPOSIT_OCR_ERROR";

export function change_investor_deposit_ocr(investorDepositId, ocr) {
  let uri = "/api/admin/change-investor-deposit-ocr";
  let types = [
    CHANGE_INVESTOR_DEPOSIT_OCR_REQUEST,
    { method: investor_deposit_ocr_changed },
    CHANGE_INVESTOR_DEPOSIT_OCR_ERROR,
  ];

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "POST",
      data: { InvestorDepositId: investorDepositId, Ocr: ocr },
      types,
    },
  };
}

export const SEND_BACK_DEPOSIT_REQUEST = "SEND_BACK_DEPOSIT_REQUEST";
export const SEND_BACK_DEPOSIT_SUCCESS = "SEND_BACK_DEPOSIT_SUCCESS";
export const SEND_BACK_DEPOSIT_ERROR = "SEND_BACK_DEPOSIT_ERROR";

export function send_back_deposit(
  investorDepositId,
  bankAccountNumber,
  bankName,
) {
  return (dispatch) => {
    let uri = "/api/admin/create-send-back-order";
    let types = [
      SEND_BACK_DEPOSIT_REQUEST,
      {
        method: (response) => {
          dispatch({
            response,
            type: SEND_BACK_DEPOSIT_SUCCESS,
          });
          dispatch(fetch_investor_deposits_to_transfer());
        },
      },
      SEND_BACK_DEPOSIT_ERROR,
    ];

    dispatch({
      [CALL_API]: {
        endpoint: uri,
        authenticatedRequest: true,
        method: "POST",
        data: {
          InvestorDepositId: investorDepositId,
          BankAccountNumber: bankAccountNumber,
          BankName: bankName,
        },
        types,
      },
    });
  };
}

export const INVESTOR_DEPOSITS_TO_TRANSFER_FETCH_SUCCESS =
  "INVESTOR_DEPOSITS_TO_TRANSFER_FETCH_SUCCESS";

export function fetch_investor_deposits_to_transfer() {
  const types = ["", INVESTOR_DEPOSITS_TO_TRANSFER_FETCH_SUCCESS, ""];
  return {
    [CALL_API]: {
      endpoint: "/api/admin/deposits-to-transfer",
      authenticatedRequest: true,
      method: "GET",
      types,
    },
  };
}

export const INVESTOR_DEPOSIT_TRANSFER_SUCCESS =
  "INVESTOR_DEPOSIT_TRANSFER_SUCCESS";

export function confirm_matched_investor_deposit(investorDepositId, depotId) {
  const types = ["", INVESTOR_DEPOSIT_TRANSFER_SUCCESS, ""];
  return {
    [CALL_API]: {
      endpoint: "/api/admin/transfer-investor-deposit",
      authenticatedRequest: true,
      method: "POST",
      data: { investorDepositId, depotId },
      types,
    },
  };
}

function investor_deposit_registered(response) {
  return (dispatch) => {
    dispatch({
      type: REGISTER_INVESTOR_DEPOSIT_SUCCESS,
      response,
    });

    dispatch(fetch_investor_deposits_to_transfer());
  };
}

function investor_deposit_ocr_changed(response) {
  return (dispatch) => {
    dispatch({
      type: CHANGE_INVESTOR_DEPOSIT_OCR_SUCCESS,
      response,
    });

    dispatch(fetch_investor_deposits_to_transfer());
  };
}

export const INVESTOR_DEPOSIT_TRANSFER_DEPOT_ID_OVERRIDE_REQUEST =
  "INVESTOR_DEPOSIT_TRANSFER_DEPOT_ID_OVERRIDE_REQUEST";
export const INVESTOR_DEPOSIT_TRANSFER_DEPOT_ID_OVERRIDE_SUCCESS =
  "INVESTOR_DEPOSIT_TRANSFER_DEPOT_ID_OVERRIDE_SUCCESS";
export const INVESTOR_DEPOSIT_TRANSFER_DEPOT_ID_OVERRIDE_ERROR =
  "INVESTOR_DEPOSIT_TRANSFER_DEPOT_ID_OVERRIDE_ERROR";

export function investordeposit_depotid_override(investorDepositId, depotId) {
  const uri = "/api/admin/get-investor-by-depot-id?Id=" + depotId;
  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "GET",
      types: [
        INVESTOR_DEPOSIT_TRANSFER_DEPOT_ID_OVERRIDE_REQUEST,
        {
          method: investordeposit_depotid_ovverride_depot_fetched.bind(
            this,
            investorDepositId,
            depotId,
          ),
        },
        {
          method: investordeposit_depotid_ovverride_depot_error.bind(
            this,
            investorDepositId,
          ),
        },
      ],
    },
  };
}

function investordeposit_depotid_ovverride_depot_fetched(
  investorDepositId,
  depotId,
  response,
) {
  return (dispatch) => {
    dispatch({
      type: INVESTOR_DEPOSIT_TRANSFER_DEPOT_ID_OVERRIDE_SUCCESS,
      InvestorDepositId: investorDepositId,
      DepotId: depotId,
      response,
    });
  };
}

function investordeposit_depotid_ovverride_depot_error(
  investorDepositId,
  response,
) {
  return (dispatch) => {
    dispatch({
      type: INVESTOR_DEPOSIT_TRANSFER_DEPOT_ID_OVERRIDE_ERROR,
      InvestorDepositId: investorDepositId,
      response,
    });
  };
}

export const REGISTER_MPL_PAYMENT_REQUEST = "REGISTER_MPL_PAYMENT_REQUEST";
export const REGISTER_MPL_PAYMENT_SUCCESS = "REGISTER_MPL_PAYMENT_SUCCESS";
export const REGISTER_MPL_PAYMENT_ERROR = "REGISTER_MPL_PAYMENT_ERROR";

export function register_mpl_payment(
  originatorCreditId,
  number,
  date,
  principal,
  interest,
  penalty,
  totalRemainingPrincipal,
  originatorId,
  creditEnded,
) {
  var uri = "/mpl-fundorders/register-repayment";

  return {
    [CALL_API]: {
      endpoint: "/api/admin" + uri,
      authenticatedRequest: true,
      method: "POST",
      data: {
        OriginatorCreditId: originatorCreditId,
        Number: number,
        Date: date,
        Principal: principal,
        Interest: interest,
        Penalty: penalty,
        TotalRemainingPrincipal: totalRemainingPrincipal,
        OriginatorId: originatorId,
        CreditEnded: creditEnded,
      },
      types: [
        REGISTER_MPL_PAYMENT_REQUEST,
        REGISTER_MPL_PAYMENT_SUCCESS,
        REGISTER_MPL_PAYMENT_ERROR,
      ],
    },
  };
}

export function register_invoice_batch_payment(batch, response) {
  return (dispatch) => {
    if (response) {
      let sendItem = batch.splice(0, 1);
      dispatch({
        type: REGISTER_INVOICE_PAYMENT_SUCCESS,
        response,
        dataSent: sendItem,
      });
    }

    if (batch.length > 0) {
      dispatch(register_invoice_payment_from_batch(batch));
    }
  };
}

function register_invoice_batch_payment_error(batch, error) {
  return (dispatch) => {
    let sendItem = batch.splice(0, 1);
    dispatch({
      type: REGISTER_INVOICE_PAYMENT_ERROR,
      error,
      dataSent: sendItem,
    });
    //alert('Failed payment: ' + batch[0].RefCode);

    if (batch.length > 0) {
      dispatch(register_invoice_payment_from_batch(batch));
    }
  };
}

function register_invoice_payment_from_batch(batch) {
  var uri = "/fundorders/invoicebg/register";
  var paymentData = {
    Amount: batch[0].Amount,
    OCR: batch[0].RefCode,
    BankReceiveDate: batch[0].BankReceiveDate,
  };

  var types = [
    REGISTER_INVOICE_PAYMENT_REQUEST,
    { method: register_invoice_batch_payment.bind(this, batch) },
    { method: register_invoice_batch_payment_error.bind(this, batch) },
  ];

  return {
    [CALL_API]: {
      endpoint: "/api/admin" + uri,
      authenticatedRequest: true,
      method: "POST",
      data: paymentData,
      types,
    },
  };
}

export const PREPARE_FOR_NEW_TRANSFER = "PREPARE_FOR_NEW_TRANSFER";

export function prepare_for_new_transfer(listLenght) {
  return {
    type: PREPARE_FOR_NEW_TRANSFER,
    additionalData: {
      plannedNumberToDo: listLenght,
    },
  };
}

export const TRANSFER_INVOICE_PAYMENT_REQUEST =
  "TRANSFER_INVOICE_PAYMENT_REQUEST";
export const TRANSFER_INVOICE_PAYMENT_SUCCESS =
  "TRANSFER_INVOICE_PAYMENT_SUCCESS";
export const TRANSFER_INVOICE_PAYMENT_ERROR = "TRANSFER_INVOICE_PAYMENT_ERROR";

export const TRANSFER_ALL_INVOICE_PAYMENT_SUCCESS =
  "TRANSFER_ALL_INVOICE_PAYMENT_SUCCESS";

export function transfer_invoice_payment(list, bankReceiveDate) {
  const uri = "/accounting/triggerpaymenttransfers";
  const _list = [...list];
  return (dispatch) => {
    if (_list.length > 0) {
      const item = _list.pop();
      const dataSent = {
        PaymentId: item.Id,
        BankReceiveDate: moment(bankReceiveDate).format("YYYY-MM-DD"),
      };

      dispatch({
        [CALL_API]: {
          endpoint: "/api/admin" + uri,
          authenticatedRequest: true,
          method: "POST",
          data: dataSent,
          types: [
            TRANSFER_INVOICE_PAYMENT_REQUEST,
            {
              method: onSuccessTransfer.bind(
                this,
                item.Amount.Amount,
                dataSent,
                _list,
              ),
            },
            { method: onErrorTransfer.bind(this, dataSent, _list) },
          ],
        },
      });
    } else
      dispatch({
        type: TRANSFER_ALL_INVOICE_PAYMENT_SUCCESS,
      });
  };
}

function onSuccessTransfer(amount, dataSent, newList, response) {
  return (dispatch) => {
    dispatch({
      type: TRANSFER_INVOICE_PAYMENT_SUCCESS,
      additionalData: {
        partAmount: amount,
      },
      dataSent,
      response,
    });
    dispatch(transfer_invoice_payment(newList, dataSent.BankReceiveDate));
  };
}

function onErrorTransfer(dataSent, newList, response) {
  return (dispatch) => {
    dispatch({
      type: TRANSFER_INVOICE_PAYMENT_ERROR,
      dataSent,
      response,
    });
    dispatch(transfer_invoice_payment(newList, dataSent.BankReceiveDate));
  };
}

export const ACCOUNTING_LIST_EUROPE_CHANGE_PAGE =
  "ACCOUNTING_LIST_EUROPE_CHANGE_PAGE";

export function change_accounting_list_page_europe(page) {
  return {
    type: ACCOUNTING_LIST_EUROPE_CHANGE_PAGE,
    page,
  };
}

export const ACCOUNTING_LIST_EUROPE_CHANGE_FILTER =
  "ACCOUNTING_LIST_EUROPE_CHANGE_FILTER";

export function change_accounting_list_filter_europe(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: ACCOUNTING_LIST_EUROPE_CHANGE_FILTER,
    filter,
  };
}

export const ACCOUNTING_LIST_SWEDEN_CHANGE_PAGE =
  "ACCOUNTING_LIST_SWEDEN_CHANGE_PAGE";

export function change_accounting_list_page_sweden(page) {
  return {
    type: ACCOUNTING_LIST_SWEDEN_CHANGE_PAGE,
    page,
  };
}

export const ACCOUNTING_LIST_SWEDEN_CHANGE_FILTER =
  "ACCOUNTING_LIST_SWEDEN_CHANGE_FILTER";

export function change_accounting_list_filter_sweden(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: ACCOUNTING_LIST_SWEDEN_CHANGE_FILTER,
    filter,
  };
}

export const INVOICE_MATCH_MANUALLY_REQUEST = "INVOICE_MATCH_MANUALLY_REQUEST";
export const INVOICE_MATCH_MANUALLY_SUCCESS = "INVOICE_MATCH_MANUALLY_SUCCESS";
export const INVOICE_MATCH_MANUALLY_ERROR = "INVOICE_MATCH_MANUALLY_ERROR";

export function match_invoice_manually(invoice, paymentId, invoicePayments) {
  var uri = "/invoices/payment/register";

  var payment = _.find(invoicePayments.data, (invoicePayment) => {
    return invoicePayment.Id == paymentId;
  });

  if (!payment) {
    var error = "Could not find a payment with this id";

    return (dispatch) => {
      dispatch({
        type: INVOICE_MATCH_MANUALLY_ERROR,
        error,
      });
      alert(error);
    };
  }

  var paymentData = {
    LoanId: invoice.AssetId,
    CustomerRefCode: payment.RefCode,
    StaffCorrectedRefCode: invoice.RefCode,
    Amount: payment.Amount.Amount,
    BankReceiveDate: payment.DateEntered.split("T")[0],
    PaymentId: paymentId,
  };

  return {
    [CALL_API]: {
      endpoint: "/api/admin" + uri,
      authenticatedRequest: true,
      method: "POST",
      data: paymentData,
      types: [
        INVOICE_MATCH_MANUALLY_REQUEST,
        INVOICE_MATCH_MANUALLY_SUCCESS,
        INVOICE_MATCH_MANUALLY_ERROR,
      ],
    },
  };
}

export function match_short_term_invoice_manually(
  invoice,
  paymentId,
  invoicePayments,
) {
  var uri = "/invoices/payment/register";

  var payment = _.find(invoicePayments.data, (invoicePayment) => {
    return invoicePayment.Id == paymentId;
  });

  if (!payment) {
    var error = "Could not find a payment with this id";

    return (dispatch) => {
      dispatch({
        type: INVOICE_MATCH_MANUALLY_ERROR,
        error,
      });
      alert(error);
    };
  }

  var paymentData = {
    LoanId: invoice.CreditId,
    CustomerRefCode: payment.RefCode,
    StaffCorrectedRefCode: invoice.RefCode,
    Amount: payment.Amount.Amount,
    BankReceiveDate: payment.DateEntered.split("T")[0],
    PaymentId: paymentId,
  };

  return {
    [CALL_API]: {
      endpoint: "/api/admin" + uri,
      authenticatedRequest: true,
      method: "POST",
      data: paymentData,
      types: [
        INVOICE_MATCH_MANUALLY_REQUEST,
        INVOICE_MATCH_MANUALLY_SUCCESS,
        INVOICE_MATCH_MANUALLY_ERROR,
      ],
    },
  };
}

export const CHANGE_PAYMENT_SEND_FLAG = "CHANGE_PAYMENT_SEND_FLAG";

export function toggle_matched_payment_sending_flag(paymentType, id) {
  return {
    type: CHANGE_PAYMENT_SEND_FLAG,
    paymentType,
    id,
  };
}

export const CHANGE_SOLVEN_PAID_PARTS = "CHANGE_SOLVEN_PAID_PARTS";

export function change_solven_paid_parts(principal, interest, fees) {
  return {
    type: CHANGE_SOLVEN_PAID_PARTS,
    principal,
    interest,
    fees,
  };
}
